import { CANON_ROOT } from './const'
import { ORDER, getProjectData } from '../project'

export const ROUTE_PREFIX = '/projects/'

const ROUTES = {}

let path = `${ROUTE_PREFIX}adam`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'adam engine',
    'adam',
    'engine',
    'game engine',
    'game',
    'web application',
    'web app',
    'webapp',
    'app',
    'open source',
    'open',
    'source',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}alwp`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'asset list webpack plugin',
    'asset-list-webpack-plugin',
    'asset',
    'list',
    'webpack',
    'plugin',
    'webpack plugin',
    'tooling',
    'open source',
    'open',
    'source',
    'package',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}checkpoint`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'checkpoint.js',
    'checkpointjs',
    'checkpoint',
    'data validation',
    'data transformation',
    'data',
    'validation',
    'transformation',
    'library',
    'open source',
    'open',
    'source',
    'package',
    'backend developer',
    'backend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}crush`
ROUTES[path] = {
  path,
  canon: `${CANON_ROOT}${path}`,
  og_img: 'http://mattlean.com/media/crush-social.png',
  og_img_secure: 'https://mattlean.com/media/crush-social.png',
  og_img_alt: 'Game board from qPCR Crush',
  og_img_width: '1200',
  og_img_height: '1200',
  og_type: 'article',
  twitter_card: 'summary',
  twitter_img: 'http://mattlean.com/media/crush-social.png',
  twitter_img_alt: 'Game board from qPCR Crush',
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'qpcr crush',
    'qpcr',
    'crush',
    'tile-matching',
    'tile matching',
    'tile-match',
    'tile match',
    'tile',
    'matching',
    'match',
    'game',
    'web application',
    'web app',
    'webapp',
    'app',
    'game developer',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}eswiss`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'design system',
    'design',
    'system',
    'component library',
    'component',
    'library',
    'swiss design',
    'swiss',
    'international typographic style',
    'open source',
    'open',
    'source',
    'package',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}ffuh`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'express-ffuh',
    'express',
    'ffuh',
    'file upload',
    'file',
    'upload',
    'middleware',
    'open source',
    'open',
    'source',
    'package',
    'backend developer',
    'backend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}yaas`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'express-yaas',
    'express',
    'yaas',
    'authentication',
    'session',
    'middleware',
    'open source',
    'open',
    'source',
    'package',
    'backend developer',
    'backend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}gridnik`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'gridnik',
    'xd plugin',
    'xd',
    'plugin',
    'adobe xd',
    'adobe xd plugin',
    'grid',
    'open source',
    'open',
    'source',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}lantern`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'lantern.js',
    'lantern',
    'lightbox',
    'image',
    'viewer',
    'library',
    'open source',
    'open',
    'source',
    'package',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}lean-space`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'lean space',
    'space',
    'personal website',
    'website',
    'personal',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'user interface designer',
    'ui designer',
    'user experience designer',
    'ux designer',
    'ui/ux designer',
    'ui & ux designer',
    'interface designer',
    'designer',
    'ui',
    'user interface',
    'ux',
    'user experience',
    'web design',
    'design',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}ljas`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'lean javascript application starter',
    'lean javascript app starter',
    'lean js application starter',
    'lean js app starter',
    'js app',
    'js',
    'app',
    'starter',
    'tooling',
    'open source',
    'open',
    'source',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'desktop app developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}ml2020`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'mattlean.com',
    'mattlean',
    'personal website',
    'website',
    'personal',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'user interface designer',
    'ui designer',
    'user experience designer',
    'ux designer',
    'ui/ux designer',
    'ui & ux designer',
    'interface designer',
    'designer',
    'ui',
    'user interface',
    'ux',
    'user experience',
    'web design',
    'design',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}owl`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'project owl',
    'project',
    'owl',
    'mobile app',
    'web application',
    'web app',
    'webapp',
    'app',
    'open source',
    'open',
    'source',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'desktop app developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
  ],
}

path = `${ROUTE_PREFIX}recha`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'recha',
    'desktop app',
    'app',
    'open source',
    'open',
    'source',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'desktop app developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'software',
    'application',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}sot`
ROUTES[path] = {
  path,
  canon: `${CANON_ROOT}${path}`,
  og_img: 'http://mattlean.com/media/sot-social.png',
  og_img_secure: 'https://mattlean.com/media/sot-social.png',
  og_img_alt: 'Chart from spectral overlay tool',
  og_img_width: '1200',
  og_img_height: '1200',
  og_type: 'article',
  twitter_card: 'summary',
  twitter_img: 'http://mattlean.com/media/sot-social.png',
  twitter_img_alt: 'Chart from spectral overlay tool',
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'spectral overlay tool',
    'spectral overlay charts',
    'lgc biosearch technologies',
    'biosearch technologies',
    'lgc',
    'data visualization',
    'data',
    'visualization',
    'charts',
    'graphs',
    'tool',
    'web application',
    'application',
    'web app',
    'webapp',
    'biotechnology',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'user interface designer',
    'ui designer',
    'user experience designer',
    'ux designer',
    'ui/ux designer',
    'ui & ux designer',
    'interface designer',
    'designer',
    'ui',
    'user interface',
    'ux',
    'user experience',
    'web design',
    'design',
    'software',
    'web',
    'project',
  ],
}

path = `${ROUTE_PREFIX}themeboot`
ROUTES[path] = {
  path,
  keywords: [
    'matt lean',
    'matthew lean',
    'matt',
    'lean',
    'themeboot',
    'wordpress theme',
    'wordpress',
    'template',
    'open source',
    'open',
    'source',
    'backend developer',
    'backend',
    'frontend developer',
    'frontend',
    'web developer',
    'developer',
    'web dev',
    'dev',
    'web engineer',
    'software engineer',
    'engineer',
    'development',
    'programmer',
    'programming',
    'user interface designer',
    'ui designer',
    'user experience designer',
    'ux designer',
    'ui/ux designer',
    'ui & ux designer',
    'interface designer',
    'designer',
    'ui',
    'user interface',
    'ux',
    'user experience',
    'web design',
    'design',
    'software',
    'application',
    'webapp',
    'web',
    'project',
  ],
}

ORDER.forEach((id) => {
  const { name } = getProjectData(id)
  const routeData = ROUTES[`${ROUTE_PREFIX}${id}`]

  if (routeData) {
    routeData.title = `Project: ${name}`
    routeData.desc = `Information about Matt Lean's project: ${name}`

    if (!routeData.og_img) {
      routeData.canon = `${CANON_ROOT}${routeData.path}`
      routeData.og_img = 'http://mattlean.com/media/social.png'
      routeData.og_img_secure = 'https://mattlean.com/media/social.png'
      routeData.og_img_alt = 'Logo for MattLean.com'
      routeData.og_img_width = '1200'
      routeData.og_img_height = '1200'
      routeData.og_type = 'website'
      routeData.twitter_card = 'summary'
      routeData.twitter_img = 'http://mattlean.com/media/social.png'
      routeData.twitter_img_alt = 'Logo for MattLean.com'
    }
  }
})

export default ROUTES
